import makeStyles from '@material-ui/core/styles/makeStyles';
import { color } from '../../app/theme';
import Tooltip from '../shared/Tooltip';
import Switch from '../shared/Switch';
import icHelpCircle from '../../assets/images/svg/ic-help-circle.svg';

const useStyles = makeStyles(
  theme => ({
    root: {
      marginBottom: 12,
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: '500',
      fontSize: '15px',
      lineHeight: 1,
      color: color.$3,
      '& > img': {
        marginLeft: 4,
      },
    },
    required: {
      color: color.$17,
    },
    input: {
      width: '542px !important',
    },
    subtitle: {
      width: '100%',
      marginTop: 8,
      '& p': {
        ...theme.typography.body1,
        color: `${color.$12}`,
        margin: '0',
        lineHeight: 1.38,
      },
      '& a': {
        color: color.$2,
        textDecoration: 'underline',
      },
    },
  }),
  {
    name: 'RowTitle',
  },
);

const RowTitle = ({
  title,
  titleStyle = {},
  isRequired,
  subtitle,
  subtitleStyle = {},
  tooltip,
  isEnableSwitch,
  isChecked = false,
  onSwitchChange,
  disabled,
  ...prop
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root} {...prop}>
      <div
        style={{
          marginBottom: 12,
        }}
      >
        {title && (
          <div className={classes.title} style={titleStyle}>
            {title}
            {isRequired && <div className={classes.required}>*</div>}
            {tooltip && (
              <Tooltip light placement="top" title={tooltip}>
                <img src={icHelpCircle} alt="plan is expired" />
              </Tooltip>
            )}
            {isEnableSwitch && (
              <Switch
                style={{ marginLeft: 4 }}
                onChange={onSwitchChange}
                checked={isChecked}
                disabled={disabled}
              />
            )}
          </div>
        )}
        {subtitle && (
          <div className={classes.subtitle}>
            <p style={subtitleStyle}>{subtitle}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RowTitle;
